<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Cash Note
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Cash Note Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="currencyList"
                label="Choose Currency..."
                item-text="name"
                menu-props="auto"
                item-value="code"
                v-model="queryParams.currencyCode"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="cashNoteList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.value }}</td>
                    <td>{{ props.item.currencyCode }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>
                      {{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}
                    </td>
                    <td>{{ props.item.updatedBy }}</td>
                    <td>
                      <v-icon
                        v-if="props.item.status == 'ACTIVE'"
                        medium
                        color="green"
                        >check_circle</v-icon
                      >
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                    <td v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
                      <v-btn
                        flat
                        icon
                        color="blue lighten-2"
                        @click="onEdit(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { cashNoteService } from "../../services/cash-note-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "CashNoteList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Counter Cash",
        disabled: true,
      },
      {
        text: "Cash Note",
        disabled: true,
      },
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Value", value: "value" },
      { text: "Currency", value: "currencyCode" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    queryParams: {
      name: "",
      currencyCode: "",
      status: "ACTIVE",
    },
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    totalRows: 0,
    cashNoteList: [],
    currencyList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getCashNoteList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.currencyCode) {
      this.queryParams.currencyCode = this.$route.query.currencyCode;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getActiveCurrency();
  },
  methods: {
    getActiveCurrency() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          let findAll = {
            code: "",
            name: "----All----"
          };
          this.currencyList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "cash-notes", query: this.queryParams });
      this.getCashNoteList();
    },
    getCashNoteList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      cashNoteService
        .getCashNoteList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.cashNoteList = res.data.cashNoteList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/cash-note/new");
    },
    onEdit(cashNote) {
      // go to details page
      this.$router.push("/cash-note/" + cashNote.id);
    },
  },
};
</script>
